"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Casestudyhero() {
  const {
    ref: leftRef,
    isVisible: leftVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const {
    ref: rightRef,
    isVisible: rightVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  return <section data-section-id="3612" id="casestudyhero" className="relative min-h-screen w-full bg-background text-foreground overflow-hidden">
      <div className="flex flex-col lg:flex-row min-h-screen">
        {}
        <div ref={leftRef} className={`relative w-full lg:w-[55%] h-[60vh] lg:h-screen overflow-hidden transition-all duration-[1200ms] ease-out ${leftVisible ? "opacity-100 scale-100" : "opacity-0 scale-[1.04]"}`}>
          <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/hotel_revenue_strategy.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/hotel_revenue_strategy.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1698330/img/hotel_revenue_strategy.png-wvc-sizes" alt="Professional hotel revenue manager analyzing data dashboards in a modern office" className="absolute inset-0 h-full w-full object-cover" loading="eager" decoding="async" />
          {}
          <div className="pointer-events-none absolute inset-0" style={{
          background: "radial-gradient(ellipse at center, transparent 55%, hsla(222, 47%, 7%, 0.25) 100%)"
        }} />

          {}
          <div className="absolute bottom-6 left-6 lg:bottom-10 lg:left-10 z-10">
            <p className="font-default text-[10px] lg:text-xs uppercase tracking-[0.25em]" style={{
            color: "hsla(0, 0%, 100%, 0.8)"
          }}>
              — Revenue Excellence / Data-Driven Growth
            </p>
          </div>
        </div>

        {}
        <div ref={rightRef} className="relative w-full lg:w-[45%] flex items-center bg-background">
          <div className="w-full px-6 py-16 sm:px-10 lg:px-16 xl:px-20 lg:py-0">
            {}
            <div className={`flex items-center gap-4 mb-8 lg:mb-10 transition-all duration-700 ease-out ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`} style={{
            transitionDelay: "100ms"
          }}>
              <span className="block h-px w-10 bg-foreground/40" />
              <span className="font-default text-[10px] sm:text-xs uppercase tracking-[0.3em] text-muted-foreground">
                Expert Insight 01
              </span>
            </div>

            {}
            <h2 className={`font-default font-bold text-foreground leading-[0.95] tracking-tight transition-all duration-1000 ease-out ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`} style={{
            fontSize: "clamp(4rem, 8vw, 7rem)",
            transitionDelay: "200ms"
          }}>
              <span className="block">Maximize your</span>
              <span className="relative inline-block">
                revenue.
                {}
                <svg aria-hidden="true" viewBox="0 0 240 12" preserveAspectRatio="none" className="absolute left-0 -bottom-2 w-[85%] h-2 text-secondary/60">
                  <path d="M2 6 Q 20 1, 40 6 T 80 6 T 120 6 T 160 6 T 200 6 T 238 6" fill="none" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" />
                </svg>
              </span>
            </h2>

            {}
            <p className={`mt-10 lg:mt-12 max-w-[380px] text-base sm:text-lg leading-relaxed text-muted-foreground font-default transition-all duration-700 ease-out ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`} style={{
            transitionDelay: "400ms"
          }}>
              Unlock your hotel's full potential with data-driven OTA strategies and expert revenue management consulting by Sunil Singh.
            </p>

            {}
            <div className={`mt-10 flex flex-col sm:flex-row gap-3 sm:gap-4 transition-all duration-700 ease-out ${rightVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3"}`} style={{
            transitionDelay: "550ms"
          }}>
              <Button asChild size="lg" className="h-12 px-7 rounded-lg bg-secondary text-primary-foreground hover:bg-secondary/90 font-default text-sm tracking-wide">
                <Link to="/ContactPage">Book a Consultation</Link>
              </Button>
              <Button asChild variant="outline" size="lg" className="h-12 px-7 rounded-lg border-foreground/30 bg-transparent text-foreground hover:bg-foreground/5 font-default text-sm tracking-wide">
                <Link to="/AboutPage">
                  Learn More <ArrowRight className="ml-1 size-4" />
                </Link>
              </Button>
            </div>
          </div>

          {}
          <div className="hidden lg:flex absolute bottom-10 right-8 xl:right-10 flex-col items-center gap-3">
            <span className="font-default text-[10px] uppercase tracking-[0.4em] text-muted-foreground" style={{
            writingMode: "vertical-rl"
          }}>
              Scroll
            </span>
            <span className="relative block h-16 w-px bg-foreground/20 overflow-hidden">
              <span className="absolute left-0 top-0 block w-px bg-secondary" style={{
              height: "40%",
              animation: "tidalScrollLine 2.2s ease-in-out infinite"
            }} />
            </span>
          </div>
        </div>
      </div>

      <style>{`
        @keyframes tidalScrollLine {
          0% { transform: translateY(-100%); }
          100% { transform: translateY(250%); }
        }
      `}</style>

      <script type="application/ld+json" dangerouslySetInnerHTML={{
      __html: JSON.stringify({
        "@context": "https://schema.org",
        "@type": "BreadcrumbList",
        "itemListElement": [{
          "@type": "ListItem",
          "position": 1,
          "name": "Home",
          "item": "https://hotelrevbaba.com/"
        }, {
          "@type": "ListItem",
          "position": 2,
          "name": "Case Studies",
          "item": "https://hotelrevbaba.com/CaseStudiesSuccessStories"
        }]
      })
    }} />
    </section>;
}